import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';

export const ENDPOINTS = deepFreeze({
    PUBLISHERS: {
        URI: () => '/api/v1/publishers/{{id}}/buyboxes',
        methods: ['get'],
        default: [],
        formatter: data => data?.items,
    },
    BUYBOXES: {
        URI: () => '/api/v1/buyboxes/{{id?}}',
        methods: ['get', 'delete', 'patch'],
        default: [],
        cacheToClear: ['/api/v1/buyboxes', '/api/v1/publishers/\\d+/buyboxes', '/api/v1/spaces/\\d+/buyboxes'],
    },
    SPACES: {
        URI: () => '/api/v1/spaces/{{id}}/buyboxes',
        methods: ['get', 'post'],
        default: [],
        cacheToClear: ['/api/v1/buyboxes', '/api/v1/publishers/\\d+/buyboxes', '/api/v1/spaces/\\d+/buyboxes'],
    },
    LANDING_PAGES: {
        URI: () => '/api/v1/publishers/{{id}}/buybox-landing-pages',
        methods: ['get'],
        default: {},
        formatter: data => data?.items || [],
    },
    CAMPAIGNS: {
        URI: () => '/api/v1/buyboxes/{{id}}/campaigns/{{campaignId?}}',
        methods: ['delete', 'patch', 'post'],
        default: [],
        cacheToClear: ['/api/v1/publishers/{{id}}/buyboxes/campaigns', '/api/v1/buyboxes/{{id}}/campaigns', '/api/v2/buyboxes/{{id}}/campaigns', '/api/v1/buyboxes/{{id}}/available-campaigns', '/api/v2/buyboxes/{{id}}/available-campaigns'],
    },
    ACTIVE_CAMPAIGNS: {
        URI: () => '/api/v2/buyboxes/{{id}}/campaigns',
        methods: ['get'],
        default: [],
        formatter: data => data?.map(item => ({ ...item.campaign, priority: item.priority })),
    },
    AVAILABLE_CAMPAIGNS: {
        URI: params => {
            const v = params?.v ? params.v : 2;
            return `/api/v${v}/buyboxes/{{id}}/available-campaigns`;
        },
        methods: ['get'],
        default: [],
        formatter: data => Object.values(data?.items || data || {}),
    },
    BUYBOX_SORT_TYPES: {
        URI: () => '/api/v1/buybox-sort-types',
        methods: ['get'],
        default: [],
    },
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
